/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminBenutzerZaehlerDto } from '../../models/lexplus-admin-benutzer-zaehler-dto';

export interface AdminBenutzerverwaltungControllerCountByStatusV1$Params {
}

export function adminBenutzerverwaltungControllerCountByStatusV1(http: HttpClient, rootUrl: string, params?: AdminBenutzerverwaltungControllerCountByStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAdminBenutzerZaehlerDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerCountByStatusV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAdminBenutzerZaehlerDto>;
    })
  );
}

adminBenutzerverwaltungControllerCountByStatusV1.PATH = '/v1/benutzerverwaltung/zaehler';
